
import store from '@/store'
const config = {
  tenantName: 'Park&Charge',
  tenantAcronym: 'PNC',
  tenantSlug: 'park-n-charge',

  /**
   * Feature Access checks
   */
  access: {
    'requestlist': ['cpo'],
    'requestlocations': ['cpo', 'municipality'],
    'realisationlist': ['cpo', 'municipality'],
    'locationlist': ['cpo'],
    'realisationbtn': ['cpo'],
    'realisationcomment': ['cpo', 'municipality'],
    'canConfirmTrafficDecisions': ['municipality'],
    'canChangeCommentStatus': ['cpo', 'municipality'],
    'canChangeStatus': ['cpo', 'municipality'],
    'automatedViews': ['cpo'],
    'generateStartDoc': ['cpo', 'municipality'],
    'admin': ['admin'],
    'reporting': ['admin'],
    'manuals': ['cpo', 'municipality', 'admin'],
    'eventlog': [],
    'export': ['admin'],
  },


  /**
   * Judgement Reasons
   */
   reasonOptions: [
    { status: 4, value: 4, text: 'Eigen parkeergelegenheid', short: 'Eigen parkeergelegenheid', custom: false },
    { status: 4, value: 5, text: 'Eigen parkeergelegenheid via VvE', short: 'VVE parkeergelegenheid', custom: false },
    { status: 4, value: 6, text: 'Laadpaal in de buurt', short: 'Laadpaal beschikbaar', custom: true, placeholder: 'Adres aanwezige laadpaal' },
    { status: 4, value: 11, text: 'Laadpaal in de buurt - beoordeling gemeente', short: 'Laadpaal beschikbaar', custom: false },
    { status: 4, value: 12, text: 'Er komt al een laadpaal in je buurt', short: 'Laadpaal beschikbaar in de buurt', custom: false },
    { status: 4, value: 7, text: 'Te weinig vraag in de buurt', short: 'Te weinig vraag', custom: false },
    { status: 4, value: 8, text: 'Alphen aan de Rijn: geen locaties beschikbaar', short: 'Alphen ad Rijn', custom: false },
    // { status: 4, value: 9, text: 'Amersfoort: geen verwijzing van de gemeente', short: 'Amersfoort', custom: false },
    { status: 4, value: 10, text: 'Anders', short: 'Anders', custom: true, placeholder: 'Schrijf hier je toelichting naar de aanvrager waarom je hem afwijst. Aanhef en afsluiting worden al toegevoegd.' },

  ],

  /**
   * Monitoring config
   */
  monitoring: {
    enabled: false,
    limit: 0.5,
  },

  /**
   * Logo and other possible tenant images config
   */
  image: {
    file: 'park-n-charge.png',
    width: 60,
  },

  /**
   * Mapbox Map & address finder options
   */
  mapOptions: {},

   /**
   * Mapbox Map Request view show/hide active layer red marker
   */
    requestMapShowActiveRedMarker: false,

  /**
   * search
   */
  search: {
    requests: {
      keys: ['summary.name', 'summary.address', 'case_ref', 'ref', 'uuid', 'search.postalcode', 'search.city'],
      placeholder: 'Zoek op referentie, naam, adres of plaats',
    },
    realisations: {
      keys: ['case_ref', 'search.Municipality', 'search.City', 'address', 'status.label', 'values.Location.PlannedRealisation.Contractor', 'values.Location.GridOperator', 'ref', 'uuid'],
      placeholder: 'Zoek op referentie, adres of stap',
    },
  },

  /**
   * Realisation statuses used for layers filtering. If true => visible
   *
   * @type {Object[]}
   */
   visibleRequestsByRealisationStatuses: {
    completed: false,
    cancelled: true,
    onhold: true,
  },

  /**
   * Visible realisations within map (toggle)
   *
   * @type {Object[]}
   */
   visibleRecordsByStatus: {
    completed: true,
    cancelled: false,
  },

  /**
   * onHold & cancel reasons
   */
  onHoldReasons: [
    { text: 'Nieuwbouw / herinrichting (geen aanzichtfoto\'s of coördinaten beschikbaar)', value: 'new-build' },
    { text: 'Op verzoek gemeente', value: 'mun-request' },
    { text: 'VKB issue (document ontbreekt, status verlopen, publicatiedatum in toekomst, bezwaar)', value: 'vkb-problem' },
    { text: 'Bezwaar VKB binnengekomen', value: 'vkb' },
    { text: 'Overig (zie toelichting)', value: 'other' },
  ],

  cancelReasons: [
    { text: 'Bezwaar VKB gegrond', value: 'vkb' },
    { text: 'Doorlooptijd te lang / technisch niet mogelijk om laadpaal te plaatsen', value: 'lead-time' },
    { text: 'Gemeente niet akkoord met meerlengte', value: 'more-length' },
    { text: 'Issue met (gemeente) grond / ruimte', value: 'ground-problem' },
    { text: 'Onterechte RP aangemaakt', value: 'unlawfull-process' },
    { text: 'Dubbele locatie', value: 'doubleLocation' },
    { text: 'Andere CPO plaatst een paal', value: 'differentCpo' },
    { text: 'Laadpaal in de buurt wordt onvoldoende gebruikt', value: 'neighboringChargingpoint' },
    { text: 'Reconstructie openbare ruimte', value: 'reconstruction' },
    { text: 'Overig (zie toelichting)', value: 'other' },
  ],

  assetManagement: {
    columns: [

    ]
  },
  // Enable the possibility to reset or cancel already saved date
  canResetDateValue: true,

  ChargingStationVersion: [
    'Master type 2 wit 65025201',
    'Master type 2 grijs 65025261',
    'Master type 3 wit 65025203',
    'Master type 3 grijs 65025221',
    'Satteliet wit 60025101',
    'Satteliet grijs 60025021',
    'EVnet type 2 wit 65000002',
  ],

  preparationDateFields: {},
  usesPlannedRealisationFields: false,

  /**
   * Asset management record table object
   */
  assetManagementFields: ({ record }) => {
    const location = record.values.Location.Location
    const currentLocation = record.CurrentLocation
    const municipality = config.municipalityOptions.find(municipality => municipality.value === record.Municipality)?.text
    const dateLastStep = new Date(record.getCurrentStepDuraction().start).toLocaleDateString('en-CA')
    const getContractorByUuid = store.getters['tenant/getContractorByUuid']

    return {
      uuid: { value: record.uuid, hidden: true },
      locationId: { value: '', label: 'Locatie ID' },
      streetAndNumber: { value: `${location.StreetName} ${location.HouseNumber}`, label: 'Straatnaam + huisnummer' },
      postCode: { value: location.PostalCode, label: 'Postcode' },
      city: { value: location.CityName, label: 'Plaatsnaam' },
      municipality: { value: municipality, label: 'Gemeente' },
      chargerIds: { value: record.values.Location.ChargerIds.map(c => c.Identifier).join(', '), label: 'Uniek laadpaal ID' },
      numberOfChargingStations: { value: currentLocation.ParkingSpots.NumberOfChargingStations, label: 'Aantal laadpalen' },
      numberOfParkingSpots: { value: currentLocation.ParkingSpots.NumberOfParkingSpots, label: 'Aantal gereserveerde parkeervakken' },
      chargingStationVersion: { value: currentLocation.CPOAdvice.ChargingStationVersion, label: 'Type laadpaal' },
      connectionValue: { value: currentLocation.GridConnection?.ConnectionValue, label: 'Type aansluiting' },
      gridOperator: { value: currentLocation.GridOperator, label: 'Netbeheerder' },
      EAN: { value: record.values.Location.DateOfCommissioning?.EAN, label: 'EAN' },
      contractor: { value: getContractorByUuid({ uuid: currentLocation.Contractor })?.label, label: 'Aannemer' },
      dateActive: { value: record.values.Location.DateOfCommissioning?.DateOfCommissioning || dateLastStep, label: 'Actief sinds' },
      domain: { value: 'Publiek', label: 'Domein' },
      finUnit: { value: currentLocation.FinUnit, label: 'SPV' },
      coordinates: { value: `${location.Latitude}, ${location.Longitude}`, label: 'Coördinaten' },
      history: { value: record.case_ref, label: 'Geschiedenis gekoppelde processen', link: record.uuid }
    }
  },

  /**
   * Municipality Options
   */
  municipalityOptions: [
    { value: '0358', text: 'Aalsmeer', disabled: false },
    { value: '0197', text: 'Aalten', disabled: false },
    { value: '0482', text: 'Alblasserdam', disabled: false },
    { value: '0484', text: 'Alphen aan den Rijn', disabled: false },
    { value: '1959', text: 'Altena', disabled: false },
    { value: '0307', text: 'Amersfoort', disabled: false },
    { value: '0362', text: 'Amstelveen', disabled: false },
    { value: '0743', text: 'Asten', disabled: false },
    { value: '0758', text: 'Breda', disabled: false },
    { value: '0216', text: 'Culemborg', disabled: false },
    { value: '0736', text: 'De Ronde Venen', disabled: false },
    { value: '0766', text: 'Dongen', disabled: false },
    { value: '0505', text: 'Dordrecht', disabled: false },
    { value: '0226', text: 'Duiven', disabled: false },
    { value: '1979', text: 'Eemsdelta', disabled: false },
    { value: '0772', text: 'Eindhoven', disabled: false },
    { value: '1924', text: 'Goeree-Overflakkee', disabled: false },
    { value: '0243', text: 'Harderwijk', disabled: false },
    { value: '0523', text: 'Hardinxveld-Giessendam', disabled: false },
    { value: '0244', text: 'Hattem', disabled: false },
    { value: '0397', text: 'Heemstede', disabled: false },
    { value: '0531', text: 'Hendrik-Ido-Ambacht', disabled: false },
    { value: '0252', text: 'Heumen', disabled: false },
    { value: '0537', text: 'Katwijk', disabled: false },
    { value: '0546', text: 'Leiden', disabled: false },
    { value: '0547', text: 'Leiderdorp', disabled: false },
    { value: '0809', text: 'Loon op Zand', disabled: false },
    { value: '0119', text: 'Meppel', disabled: false },
    { value: '1952', text: 'Midden-Groningen', disabled: false },
    { value: '1709', text: 'Moerdijk', disabled: false },
    { value: '0356', text: 'Nieuwegein', disabled: false },
    { value: '0569', text: 'Nieuwkoop', disabled: false },
    { value: '0575', text: 'Noordwijk', disabled: false },
    { value: '0579', text: 'Oegstgeest', disabled: false },
    { value: '1586', text: 'Oost Gelre', disabled: false },
    { value: '1509', text: 'Oude IJsselstreek', disabled: false },
    { value: '0590', text: 'Papendrecht', disabled: false },
    { value: '0273', text: 'Putten', disabled: false },
    { value: '0279', text: 'Scherpenzeel', disabled: false },
    { value: '1676', text: 'Schouwen-Duiveland', disabled: false },
    { value: '0610', text: 'Sliedrecht', disabled: false },
    { value: '0855', text: 'Tilburg', disabled: false },
    { value: '0716', text: 'Tholen', disabled: false },
    { value: '0352', text: 'Wijk bij Duurstede', disabled: false },
    { value: '0866', text: 'Waalre', disabled: false },
    { value: '0632', text: 'Woerden', disabled: false },
    { value: '0297', text: 'Zaltbommel', disabled: false },
    { value: '0642', text: 'Zwijndrecht', disabled: false },

    // Newly added municipalities but not yet functional 01 feb. 2023 TOOLS-2559 //
    // { value: '0200', text: 'Apeldoorn', disabled: false },
    // { value: '0202', text: 'Arnhem', disabled: false },
    // { value: '0203', text: 'Barneveld', disabled: false },
    // { value: '1891', text: 'Dantumadiel', disabled: false },
    // { value: '0150', text: 'Deventer', disabled: false },
    // { value: '0222', text: 'Doetinchem', disabled: false },
    // { value: '0228', text: 'Ede', disabled: false },
    // { value: '0232', text: 'Epe', disabled: false },
    // { value: '0233', text: 'Ermelo', disabled: false },
    // { value: '0160', text: 'Hardenberg', disabled: false },
    // { value: '0074', text: 'Heerenveen', disabled: false },
    // { value: '0164', text: 'Hengelo', disabled: false },
    // { value: '0402', text: 'Hilversum', disabled: false },
    // { value: '0080', text: 'Leeuwarden', disabled: false },
    // { value: '0263', text: 'Maasdriel', disabled: false },
    // { value: '0687', text: 'Middelburg', disabled: false },
    // { value: '0268', text: 'Nijmegen', disabled: false },
    // { value: '1970', text: 'Noardeast-Fryslân', disabled: false },
    // { value: '1773', text: 'Olst-Wijhe', disabled: false },
    // { value: '0275', text: 'Rheden', disabled: false },
    // { value: '0277', text: 'Rozendaal', disabled: false },
    // { value: '0518', text: 's-Gravenhage', disabled: false },
    // { value: '0180', text: 'Staphorst', disabled: false },
    // { value: '0345', text: 'Veenendaal', disabled: false },
    // { value: '0285', text: 'Voorst', disabled: false },
    // { value: '0866', text: 'Waalre', disabled: false },
    // { value: '0296', text: 'Wijchen', disabled: false },
    // { value: '0299', text: 'Zevenaar', disabled: false },
    // { value: '1896', text: 'Zwartewaterland', disabled: false },

    { value: '9018', text: 'Intern - EVnetNL', disabled: false },
  ],
  /**
   * Grid operators overrides per tenant
   */
  operatorsByMunicipalityCode: {},

  /**
   * Commonly used contractors based on municipality
   */
   contractorsByMunicipalityCode: {
    '1509': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '1586': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '1709': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '1773': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '1891': 'e039b00a-5f21-4ac3-862f-652bf2bae71c',  // BAAS
    '1896': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '1924': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '1952': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '1959': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '1970': 'e039b00a-5f21-4ac3-862f-652bf2bae71c',  // BAAS
    '1979': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '0279': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0632': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0537': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0358': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0523': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0547': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0299': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0233': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0180': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '0277': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0164': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '0216': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0268': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0243': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0285': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0203': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0200': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0356': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0546': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0743': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '0766': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '0307': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0569': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0362': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0232': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0397': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0275': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0531': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0484': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0855': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '0222': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0226': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0150': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '0197': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0119': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '0758': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '0575': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0263': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0202': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0273': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0866': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '0074': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '0297': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0610': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0579': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0590': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0345': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0296': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0687': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0716': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0402': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0809': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '0252': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0228': '53401a9c-5044-4a20-942e-89f8a2a500a9',  // Van Gelder Oost
    '0505': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0080': 'cf5b0d18-b6e4-44e4-a305-d1f4db13381e',  // Van Gelder West
    '0736': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0642': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
    '0160': '98d631ce-805d-4c31-8d9d-70a8a2408183',  // Van Gelder Noord
    '0518': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0772': 'adcef5ae-90d7-4085-94a8-3f1d330dcab0',  // STEEN BV
    '0244': 'e039b00a-5f21-4ac3-862f-652bf2bae71c',  // BAAS
    '0482': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '0352': '743673f6-c2ef-48a7-9b20-c6bc42d7c1ef',  // Quint
    '1676': '8de24014-bd1c-4b05-831a-61aa1ad2c51f',  // HAK
  },
}
 export default config